<template>
    <v-dialog
        v-model="dialog"
        width="450"
        transition="fab-transition"
    >
        <v-card v-if="sale" class="pl-0 pb-0" >
            <v-card-title >
                <v-container class="pt-0 pb-0 " style="display: flex;">
                    <v-row style="justify-content: center;">
                        <span class="description-selected" >
                            {{ title }}
                        </span>
                    </v-row>
                </v-container>
            </v-card-title>
            <v-divider></v-divider>
                <v-container class="pt-0 pb-0">
                    <div style="display:flex;">
                        <label style="font-weight: bold;font-size: 1.0rem;">Envio Nubefact: </label>
                        <v-icon size="24" color="#00DD00" v-if="sendNubefact">✔</v-icon>
                        <v-icon size="24" color="#FF0000" v-else>✖</v-icon>
                        <!-- <v-icon size="24">fa-solid fa-xmark</v-icon> -->
                        <!-- <font-awesome-icon icon="fa-solid fa-check" /> -->
                        <!-- <font-awesome-icon icon="fa-solid fa-xmark" /> -->
                    </div>
                </v-container>
                <!-- <v-container class="pt-0 pb-0">
                    <div style="display:flex;">
                        <label style="font-weight: bold;font-size: 1.0rem;">Genero Credito De Nota: </label>
                        <v-icon size="24" color="#00DD00" v-if="creditNote">✔</v-icon>
                        <v-icon size="24" color="#FF0000" v-else>✖</v-icon>
                    </div>
                </v-container> -->
                <v-container class="pt-0 pb-0">
                    <div style="display:flex;">
                        <label style="font-weight: bold;font-size: 1.0rem;" >Motivo: </label>
                        <div style="margin-left: 5px;">
                            {{reason}}
                        </div>
                    </div>
                </v-container>
                <!-- <v-container class="pt-0 pb-0 ">
                    <div style="text-align: center;">
                       <label for="labe-reason" style="font-weight: bold;font-size: 1.2rem;">Motivo</label>
                       <div>
                           {{reason}}
                       </div>
                    </div>
                </v-container> -->
            <v-card-actions>
                <v-container class="pt-0 pb-0 " style="display: flex;">
                    <v-row style="justify-content: center;">
                        <v-col cols="6">
                            <v-btn dark color="#B0B0B0" block @click="handleCerrar">
                                Cerrar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>                    
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'ReasonForCancel',
    data () {
        return {
            dialog: false,
            title: null,
            reason:null,
            sendNubefact: false,
            // creditNote: false,
            sale: {},
        }
    },
    computed: {
    },
    methods: {
        show (sale) {
            this.title = sale.type_document + "  " + sale.serie + " - " +sale.correlative;
            this.reason = sale.canceled_reason;
            this.sendNubefact = sale.sent_invoice? true : false;
            // this.creditNote = sale.credit_sale ? true:false; 
            this.dialog = !this.dialog;
        },
        closeForm() {
            this.dialog = false;

        },
        handleCerrar () {
            this.closeForm();
        },
    }
}
</script>